<template>
  <section>
    <div class="container">
      <div class="breadcrumbs">
        <router-link :to="{ name: 'psychologists.index' }" class="breadcrumbs__item">{{this.$vuetify.lang.t('$vuetify.main.header.menu.ourPsychologists')}}</router-link>
        <span class="triangle-divider"></span>
        <span class="breadcrumbs__item">{{profile.full_name}}</span>
      </div>
      <div class="profile__wrapper">
        <psychologist-data 
          :profile="profile"
          :is-load="isLoad"
          :save-psychologist-and-time-slot="savePsychologistAndTimeSlot"
          :save-new-psychologist-on-server="saveNewPsychologistOnServer"
        ></psychologist-data>
      </div>
    </div>
  </section>
</template>

<script>
import Vue from "vue";
import { mapGetters } from "vuex";
import PsychologistData from '@/components/main/ShowPsychologist/PsychologistData'
//import store from '@/store'

export default {
  name: 'PsychologistsShow',
  components: {
    PsychologistData
  },
  data() {
    return {
      selectedNewPsychologistByPatient: {},
      isLoad: false,
    };
  },
  /* beforeRouteEnter (routeTo, RouteFrom, next) {
    store.dispatch('user/getPsychologistProfile', { profile_id: routeTo.params.profile_id })
      .then(() => {
        next(() => {
          //
        })
      })
  }, */
  created () {
    this.isLoad = true;

    this.$store.dispatch('user/getPsychologistProfile', {
      profile_id: this.$route.params.profile_id
    })
    .finally(() => {
      this.isLoad = false;
    });

    if (Object.keys(this.$route.query).length > 0) {
      this.$router.replace({ path: this.$route.path })
    }
  },
  computed: {
    ...mapGetters({
      user: "user/getUser",
    }),
    selectCalendarId() {
      return this.$store.getters["user/getChosenCalendarId"];
    },
    profile () {
      return this.$store.getters['user/getPsychologistProfile']
    },
    getUserRole: function () {
      return this.user.role;
    },
    getCurrentTimeSlotId: function () {
      return this.user.next_consultation ? this.user.next_consultation.id : "";
    },
  },
  watch: {
    profile () {
      if(!this.profile.works_with_couples) {
        this.setConsultationType(1);
      }
    },
    $route(to) {
      if (Object.keys(to.query).length === 0) {
        this.processSelectCalendar();
      }
    }
  },
  methods: {
    processSelectCalendar() {
      if(this.selectCalendarId) {
        let selectCalendarId = this.selectCalendarId;
        this.$store.dispatch('user/setChosenCalendarId', null)
        this.$store.dispatch('user/setChosenPsychologistId', null)
        this.bookCalendarOnServer(this.profile.id, selectCalendarId, true);
      }
    },
    setConsultationType(consultation_type) {
      this.$store.dispatch('consultation_type/setConsultationType', consultation_type)
    },
    savePsychologistAndTimeSlot(psychologistInfo = {}) {
      this.selectedNewPsychologistByPatient = psychologistInfo;
    },
    async bookCalendarOnServer(psychologistId, calendarId, processRedirect = false) {
      if (this.getCurrentTimeSlotId) {
          await this.$store
            .dispatch("user/cancelConsultationByPatient", {
              id: this.getCurrentTimeSlotId,
            })
            .then((response) => {
              if (response.status === 200) {
                this.getNotificationForResponse(response);
              }
            });
        }

        await this.$store
          .dispatch("user/updateProfile", {
            questionnaire: { profile_id: psychologistId },
          })
          .then((response) => {
            if (response.status === 200) {
              this.getNotificationForResponse(response);
            }
          });

        await this.$store
          .dispatch("user/bookTimeSlotByPatient", {
            calendar_id: calendarId,
            consultation_type_id: this.$store.getters['consultation_type/getSelectedConsultationType'],
          })
          .then((response) => {
            if (response.status === 200) {
              this.getNotificationForResponse(response);
              if (processRedirect) {
                this.$router.push('/dashboard/main');
              }
            }
          });
    },
    async saveNewPsychologistOnServer(psychologistId) {
      // let payload = {};

      if (
        psychologistId &&
        Object.keys(this.selectedNewPsychologistByPatient).length === 0
      ) {
        if (this.getCurrentTimeSlotId) {
          await this.$store
            .dispatch("user/cancelConsultationByPatient", {
              id: this.getCurrentTimeSlotId,
            })
            .then((response) => {
              this.getNotificationForResponse(response);
            });
        }

        await this.$store
          .dispatch("user/updateProfile", {
            questionnaire: { profile_id: psychologistId },
          })
          .then((response) => {
            if (response.status === 200) {
              if (response.status === 200) {
                this.getNotificationForResponse(response);
              }
            }
          });
      }

      if (Object.keys(this.selectedNewPsychologistByPatient).length > 0) {
        
        await this.bookCalendarOnServer(psychologistId, this.selectedNewPsychologistByPatient.timeSlot.slot.id);
        
      }
      this.selectedNewPsychologistByPatient = {};
      await this.$store.dispatch("user/getProfile", {});
      await this.$store.dispatch('user/getPsychologistProfile', { profile_id: this.profile.id })
    },
    getNotificationForResponse(response, timer = 3500, position = "top-right") {
      Vue.swal({
        target: document.getElementById("main"),
        text: response.data.message,
        icon: "success",
        timer: timer,
        toast: true,
        position: position,
        showConfirmButton: false,
      });
    },
  },
}
</script>

<style lang="scss" scoped>
.profile__wrapper {
  margin-top: 60px;
  margin-bottom: 60px;
}
.triangle-divider {
  display: inline-block;
  width: 0;
  height: 0;
  margin: 0 8px;
  vertical-align: middle;
  border-top: 5px solid transparent;
  border-bottom: 5px solid transparent;
  border-left: 5px solid #D9E4EB;
}
.breadcrumbs {
  display: flex;
  column-gap: 28px;
  flex-wrap: wrap;
  margin-top: 50px;
  align-items: center;
}
.breadcrumbs__item {
  color: #D9E4EB;
  text-decoration: none;
}
</style>